import { useMemo, useState } from 'react'
import { autoRabbit, manualRabbit } from './ggRabbit.js'
import { samplePlayers } from './ggSamplePlayers.js'

// G-Rabbit — isolated sandbox. Auto-settle (ON) computes the holder from the
// scorecard alone (outright hole winners, carried, half-at-9 / half-at-18).
// Manual (OFF) is the track-it-yourself fallback: pick the holders yourself.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }
const Seg = ({ options, value, onChange }) => (
  <div className="flex items-center gap-1 rounded-lg p-1" style={{ backgroundColor: '#F3F4F6', border: '1px solid #E5E7EB' }}>
    {options.map((o) => {
      const on = value === o.value
      return <button key={String(o.value)} onClick={() => onChange(o.value)} className="rounded-md px-3 py-1 text-xs font-bold uppercase tracking-wider transition"
        style={on ? { backgroundColor: '#1B4D2E', color: '#fff' } : { backgroundColor: 'transparent', color: '#374151' }}>{o.label}</button>
    })}
  </div>
)

export default function GRabbit() {
  const players = useMemo(() => samplePlayers(), [])
  const [auto, setAuto] = useState(true)
  const [frontPot, setFrontPot] = useState(10)
  const [backPot, setBackPot] = useState(10)
  const [mFront, setMFront] = useState('')
  const [mBack, setMBack] = useState('')
  const pots = { frontPot: Number(frontPot) || 0, backPot: Number(backPot) || 0 }

  const r = useMemo(
    () => (auto ? autoRabbit(players, pots) : manualRabbit(mFront || null, mBack || null, pots)),
    [auto, players, mFront, mBack, frontPot, backPot],
  )
  const name = (id) => (id ? players.find((p) => p.id === id)?.name || id : '— loose —')

  return (
    <div className="card">
      <div className="flex flex-wrap items-center gap-3 mb-3">
        <Seg options={[{ value: true, label: 'Auto-settle' }, { value: false, label: 'Manual' }]} value={auto} onChange={setAuto} />
        <span className="text-sm text-gray-600 font-semibold">Front $<input type="number" className="w-14 border rounded px-1 py-0.5 ml-1" value={frontPot} onChange={(e) => setFrontPot(e.target.value)} /></span>
        <span className="text-sm text-gray-600 font-semibold">Back $<input type="number" className="w-14 border rounded px-1 py-0.5 ml-1" value={backPot} onChange={(e) => setBackPot(e.target.value)} /></span>
      </div>
      {!auto && (
        <div className="flex flex-wrap items-center gap-3 mb-3 text-xs">
          <label className="font-semibold text-gray-600">Front holder <select className="border rounded px-1 py-0.5 ml-1" value={mFront} onChange={(e) => setMFront(e.target.value)}><option value="">— none —</option>{players.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</select></label>
          <label className="font-semibold text-gray-600">Back holder <select className="border rounded px-1 py-0.5 ml-1" value={mBack} onChange={(e) => setMBack(e.target.value)}><option value="">— none —</option>{players.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</select></label>
        </div>
      )}
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Leg', 'Holder', 'Pot'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>
          <tr><td style={cell}>Front (after 9)</td><td style={cell}><b>{name(r.frontHolder)}</b></td><td style={cell}>${pots.frontPot}</td></tr>
          <tr><td style={cell}>Back (after 18)</td><td style={cell}><b>{name(r.backHolder)}</b></td><td style={cell}>${pots.backPot}</td></tr>
        </tbody>
      </table>
      <p className="text-sm text-gray-500 mt-2">{auto ? '🐰 Holder derived from the scorecard (outright hole winners, carried).' : '🐰 Manual — record the holders you tracked; auto-settle stays available as a toggle.'}</p>
    </div>
  )
}
